<template>
  <section class="success">
    <popup-base
      v-show="wantToMakeOffer"
      class="popo md:pt-10 md:pb-4 w-full"
      @clickOnBackground="logState"
    >
      <div class="cardinal mr-auto ml-auto p-5">
        <div
          class="success-container h-full pt-6"
        >
          <div class="text-left flex pl-6 pr-6">
            <div
              class="text-c24 font-c7 w-4/5"
            >
              Ajouter une marque
            </div>
            <div class="w-1/5 flex justify-end">
              <icon
                :data="icons.fermer"
                height="30"
                width="30"
                class="cursor-pointer"
                original
                @click="fermer"
              />
            </div>
          </div>

          <div class="text-c18 font-c4 mt-4 bg-white p-6 pb-12">
            <div class="text-left text-c12 mt-6">
              Nom
            </div>
            <inputo
              class="mt-2"
              placeholder="Dolce & Gabana"
              @info="retourNom"
            />

            <div class="mt-8">
              <stock @info="retourStock"/>
            </div>

            <div
              v-if="error !== null"
              class="mt-6 text-red text-c14"
            >
              {{ error }}
            </div>
          </div>

          <div class="flex">
            <div class="w-full">
              <buton
                label="Enregistrer"
                radius="0px"
                height="55px"
                :charge="charge"
                @oga="continuer"
              />
            </div>
          </div>
        </div>
      </div>
    </popup-base>
  </section>
</template>

<script>
import PopupBase from '../helper/add/popupfat'
import buton from '../helper/add/button'
import fermer from '../../assets/icons/fermer.svg'
import inputo from '../helper/form/input'
import apiroutes from "../../router/api-routes"
import http from "../../plugins/https"
import stock from '../cdevs/marques/formStock'

export default {
  name: 'Success',
  components: { PopupBase, buton, inputo, stock },

  props: {
    activation: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      wantToMakeOffer: false,
      icons: {
        fermer
      },
      nom: '',
      error: null,
      charge: false,
      limite: '',
      stockData: null
    }
  },

  created() {
    this.wantToMakeOffer = this.activation
  },

  methods: {
    fermer () {
      this.$emit('oga', false)
    },

    retourLimite(answer) {
      this.limite = answer
    },

    continuer () {
      this.charge = true
      this.error = null
      if (this.nom.length > 0) {
        let body = {
          label: this.nom,
        }
        this.save(body)
      } else {
        this.charge = false
        this.error = 'Veuillez entrer le nom de la marque pour continuer'
      }
    },

    retourStock (answer) {
      this.stockData = answer
    },

    save (body) {
      http.post(apiroutes.baseURL + apiroutes.createMarque, body)
          .then(response => {
            console.log(response)
            this.charge = false
            this.saveStock(response.id)
          })
          .catch(error => {
            this.charge = false
            console.log(error)
            this.error = "Problème de connexion. Veuillez ressayer"
          })
    },

    saveStock (id) {
      const stock = this.stockData

      for (let i in stock) {
        stock[i].brand = id
      }

      http.post(apiroutes.baseURL + apiroutes.limitStock, {limitation: stock})
          .then(response => {
            console.log(response)
            this.charge = false
            this.$emit('oga', false)
          })
          .catch(error => {
            this.charge = false
            console.log(error)
            this.error = "Problème de connexion. Veuillez ressayer"
          })
    },

    retourNom (answer) {
      this.nom = answer
    },

    logState (answer) {
      this.wantToMakeOffer = answer
      this.$emit('oga', false)
    }
  }
}
</script>

<style lang="scss"  scoped>
    @import "../../assets/styles/sass/mixin";
    .success {
      z-index: 999;
    }
    .cardinal {
      width: 42%;
    }

    .success-container {
      font-family: $font-default;
      width: 100%;
      background-color: #F5F5F5;
      height: auto;
      margin: auto;
      border-radius: 12px;
    }
    @media screen and (max-width: 700px){
      .success-container {
        width: 100%;
        height: 100vh;
      }
      .titre {
        font-size: 18px;
      }
      .bloc1 {
        width: 100%;
      }
      .bloc2 {
        width: 100%;
        font-size: 18px;
      }
      .button {
        width: 100%;
        font-size: 16px;
      }
      .cardinal {
        width: 100%;
      }
    }

    @media screen and (max-width: 1024px) and (min-width: 770px){
      .cardinal{
        width: 65%;
      }
      .titre{
        font-size: 18px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 19px;
      }
    }

    @media screen and (max-width: 769px) and (min-width: 701px){
      .cardinal{
        width: 90%;
      }
      .titre{
        font-size: 18px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 19px;
      }
    }
    @media screen and (max-width: 320px){
      .cardinal{
        width: 100%;
      }
      .titre{
        font-size: 14px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 15px;
      }
    }
</style>
